import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import Field from "./field";
import Grid from "@mui/material/Grid2";
import { Refresh, MoreHorizOutlined } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";

function Widget(props) {
  const { scrDefinition, wData } = props;
  const jprop = JSON.parse(wData.JPROP) || {};
  const [isLoading, setLoading] = useState(false);
  {
    /*<div
      id={`sw-${wData.WIDGET_ID}`}
      key={wData.WIDGET_ID}
      className="scr-widget"
      style={{flexGrow: jprop.grow}}
    >*/
  }

  return (
    <Grid
      id={`sw-${wData.WIDGET_ID}`}
      key={wData.WIDGET_ID}
      className="scr-widget"
      size={jprop.size}
    >
      <div id={`swh-${wData.WIDGET_ID}`} className="widget-header">
        <div id={`swt-${wData.WIDGET_ID}`} className="widget-title">
          {wData.TITLE}
          {JSON.stringify(jprop.size)}
          {wData.WIDGET_ID}
        </div>
        <div id={`swa-${wData.WIDGET_ID}`} className="widget-actions">
          <IconButton
            aria-label="refresh"
            size="small"
            disabled={isLoading}
            onClick={() => setLoading(true)}
          >
            {isLoading ? (
              <CircularProgress size="15px" />
            ) : (
              <Refresh fontSize="small" color="primary" />
            )}
          </IconButton>
          <IconButton
            aria-label="refresh"
            size="small"
            disabled={isLoading}
            //onClick={() => setLoading(true)}
          >
            <MoreHorizOutlined fontSize="small" /*color="primary"*/ />
          </IconButton>
        </div>
      </div>
      <div id={`swb-${wData.WIDGET_ID}`} className="widget-main">
        {scrDefinition?.fields
          ?.filter((fw) => fw.WIDGET_ID == wData.WIDGET_ID)
          ?.map((f) => {
            return <Field id={`sf-${f.FIELD_ID}`} key={f.FIELD_ID} fData={f} />;
          })}
      </div>
      <div id={`swf-${wData.WIDGET_ID}`} className="widget-footer">
        {jprop?.save && (
          <div id={`swas-${wData.WIDGET_ID}`}>{jprop.save.caption}</div>
        )}
        {jprop?.cancel && (
          <div id={`swac-${wData.WIDGET_ID}`}>{jprop.cancel.caption}</div>
        )}
      </div>
    </Grid>
  );
}
export default observer(Widget);
